import type { ObligationAssessmentResultsByObligationIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetObligationAssessmentResultsByObligationIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetObligationAssessmentResultsByObligationIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetObligationAssessmentResultsByObligationIdArgs = {
  obligationId: string;
};

export const useLazyGetObligationAssessmentResultsByObligationId =
  createLazyQueryHook<
    UseLazyGetObligationAssessmentResultsByObligationIdArgs,
    ObligationAssessmentResultsByObligationIdResponseRow[],
    GetObligationAssessmentResultsByObligationIdQuery
  >({
    trpcQuery: (client, { obligationId }) =>
      client.frontend.obligationAssessmentResult.obligationAssessmentResultsByObligationId.query(
        { obligationId }
      ),
    mapTrpcDataToGraphQL: (data) => ({ obligation_assessment_result: data }),
    graphqlDocument: GetObligationAssessmentResultsByObligationIdDocument,
    graphqlVariables: ({ obligationId }) => ({ ObligationId: obligationId }),
  });
